/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

export default {
  energyManagement: {
    REFRESH: 'Refresh',
    ENERGYPERFORMANCE: 'Energy Savings',
    UTILITYBILLSAVINGS: 'Utility Bill Charges ',
    DateFrom: 'Date from',
    SITES: 'Sites',
    ENERGYMANAGEMENTDASHBOARDTITLE: 'Energy Management Score',
    BASELINE: 'Baseline',
    BASELINEKEY: 'baselineConsumption',
    ACTUALKEY: 'ActualConsumption',
    SAVINGS: 'Savings',
    ACTUAL: 'Actual',
    PARTIAL_MONTH: 'Partial Month',
    ACTUALEMISSIONS: 'Actual Emissions',
    ACTUALEMIS: 'Actual Emis.',
    PREVIOUSEMIS: 'Previuos Emis.',
    PREVIOUSEMISSIONS: 'Previous Emissions',
    TOTALCONSUMPTION: 'Total Consumption',
    EMISSION: 'Emissions',
    ACTUALAVOIDANCE: 'Actual Avoidance',
    PREVIOUSPERIOD: 'Previous Period',
    PREVIOUS: 'Previous',
    PREVIOUSAVOIDANCE: 'Previous Avoidance',
    ACTUALCOST: 'Actual Cost',
    actualCost: 'ACTUAL CONS.',
    BASELINECOST: 'Baseline Cost',
    baselineCost: 'BASELINE CONS.',
    PREVSPER: 'PREVIOUS PERIOD',
    PREVIOUSCOST: 'Previous Cost',
    VIEWDETAILS: 'VIEW DETAILS',
    ADVANCED: 'Advanced',
    BASIC: 'Basic',
    MONTHLY: 'Monthly',
    BILLING: 'Billing',
    LIVEMETER: 'Live Meters',
    UTILITYMETER: 'Utility Meters',
    LIVEREADING: 'Onsite Meters',
    UTILITYINTERVAL: 'Utility Interval',
    UTILITYPROVIDERNEW: 'Utility Monthly',
    ACTUALCONSUMPTION: 'Actual Consumption',
    BASELINECONSUMPTION: 'Baseline Consumption',
    PREDICTED: 'Predicted',
    Utilitycost: 'Utility Cost for',
    UtilityBill: 'Utility Bill Overview',
    UtilityCost: 'Utility Cost',
    ActualCost: 'Actual Cost',
    CostPercentage: 'Cost %',
    Electricity: 'Electricity',
    Gas: 'Gas',
    Water: 'Water',
    UtilityType: 'Utility Type',
    all: 'all',
    electricity: 'electricity',
    gas: 'gas',
    water: 'water',
    BASICSITEWITHDATACOUNTMESSAGE:
      '* Utility bills for energy consumption have been generated for {siteWithDataCount} of {totalSiteCount} sites.',
    CARBONUTILITYGRAPHTOOLTIP:
      '* Emissions for utility bills have been generated for {siteWithDataCount} of {totalSiteCount} sites.',
    CARBONLIVEGRAPHTOOLTIP:
      '* Emissions for live readings have been generated for {siteWithDataCount} of {totalSiteCount} sites.',
    ENERGYUTILITYGRAPHTOOLTIP:
      '* Utility bills energy consumptions have been generated for {siteWithDataCount} of {totalSiteCount} sites.',
    ENERGYLIVEGRAPHTOOLTIP:
      '* Live readings have been generated for {siteWithDataCount} of {totalSiteCount} sites.',
    UtilityTypeforselectutility: 'Utility Type*',
    ENABLEIDSCHECKBOX: 'Enable IDS (Interval Data Service)',
    ENABLED: 'Enabled',
    DISABLED: 'Disabled',
    CONVERSIONINFOMSG: `Please provide your credentials to enable conversion of this Account Number from a ‘Manual’ to an ‘Automatic’ Integration Type. Once the 
    credentials are verified, the integration type will be updated automatically. The manually saved data would remain and the upcoming bills 
    would be updated automatically thereafter.`,
    CO2: 'CO2',
    CARBON: 'Carbon({unit})',
    CARBONNOUNIT: 'Carbon',
    CARBONEMISSION: 'Carbon Emissions',
    METERDATA1: 'Meter Data',
    DATANEEDED: 'Data Needed',
    METERDATA: 'Meter Data',
    METERDATASUBTITLE:
      'Analyze and compare meter consumption by uploading historical and / or missing period data.',
    EUI: 'EUI({preferredEuiUnit})',
    ELECTRICITYCONSUMPTION: 'ELECTRICITY CONSUMPTION',
    ELECTRICITYPERFORMANCE: 'Electricity Performance',
    Electicity:
      ' Electicity, Gas, Water data can be integreated with linking your accounts',
    FORECAST: 'Forecast',
    ALL: 'All',
    ELECTRICITY: 'Electricity',
    GAS: 'Gas',
    WATER: 'Water',
    METER: 'METER',
    SavingMeter: 'Savings by Meter',
    BREAKDOWNMETER: 'Cons. by Meters',
    BREAKDOWNBYAREAS: 'Breakdown by Areas',
    BREAKDOWNBYEQUIPMENTTYPE: 'Breakdown by Equipment Type',
    CONSUMPTIONBYUTILITIES: 'Cons. by Utilities',
    ENERGYBREAKDOWNOFUTILITY: 'Breakdown of Utility',
    ENERGYBREAKDOWNBYMETERS: 'Breakdown by Meters',
    WATERBREAKDOWNBYLIVEMETERS: 'Breakdown by Live Meters',
    BREAKDOWNOFUTILITY: 'Breakdown of Utility charges',
    breakdownUtility: 'Breakdown By Utilities',
    breakdownCarbon: 'Breakdown of Meters',
    breakdownCarbonScopeOne: 'Breakdown by Category',
    breakdownFuel: 'Breakdown of Fuel Types',
    breakdownAreas: 'Breakdown by Areas',
    areasHeader: ' Areas',
    metersHeader: 'Meters',
    areasSubHeaders:
      'The following electricity usage breakdown is according to areas and for selected duration.',
    baselinebutton: 'Baseline',
    LAST_BASELINE_TRAINED_DATE: 'Last baseline trained on',
    apply: 'Apply',
    back: 'Back',
    baselinetraning: 'Baseline Training',
    chooseTrainingDateRange: 'Choose training date range',
    applyBaselineFrom: 'Apply baseline from',
    historicDataTooltip:
      'For the historical uploaded data, baseline will be visible for last 15 days in the Dashboard and reports.',
    excludeSpecificDateRangeQ:
      'Do you prefer to exclude a specific date range?',
    excludeDateRange: 'Exclude date range',
    howitworks: 'How it works?',
    howitworksone:
      'All the meter data uploaded will be utilized to train a good quality baseline model',
    howitworkstwo:
      'The baseline data will be displayed on the Dashboard and in reports for last 15 days from the date of upload',
    howitworksthree:
      'To achieve best baseline results, it is recommended to have a 12 months of data',
    howitworksfour: 'Minimum 30 days of data is necessary for model training',
    howitworksfive: 'Baseline training is applied to data from all site meters',
    howitworkssix:
      'When you retrain the baseline model, the existing model with be replaced based on the new baseline training period',
    baselinedaterangeheader: 'Choose baseline training period',
    baselinedaterangesubheader:
      'Select the date range for the baseline model, whether you wish to include or exclude a specific period.',
    redirectmsg1: 'You will be redirected in',
    redirectmsg2: 'sec.',
    uploadingmsg:
      'Please hold while we initiate the process to train the baseline, and we will notify you via email once it’s completed.',
    meterSubHeaders:
      'The table provides a breakdown of meters in the site along with various KPIs.',
    breakdownCarbonSites: 'Carbon Emissions by Sites ({count})',
    ENERGYUSAGE: 'Energy Usage',
    ENERGYUSAGECONSUMPTION: 'Consumption',
    USAGEConsumption: 'Consumption',
    WATERUSAGE: 'Water Usage',
    NILMTOOLTIPHEADER: 'Non-Instrusive Load Monitoring (NILM)',
    NILM: 'NILM',
    ENERGYDISAGGREGATION: 'Energy Disaggregation',
    ENERGYUSAGEOVERVIEW: 'Energy Usage Overview',
    CONSUMPTIONOVERVIEW: 'Consumption Overview',
    LOADING: 'Loading',
    SUBMITTING: 'Submitting',
    NODATAAVAILABLE: 'No data for selected date period',
    UTILITYYEAROUTOFRANGE: 'Please select date range within a year',
    NOTSUBSCRIBED: 'Not Subscribed',
    CONNECTIONERROR:
      'We were unable to connect to the\nservice. Please try again',
    CONNECTIONERRORTITLE: 'Connection error!',
    WATERTOOLTIPHEADER: 'Water Consumption',
    CARBONSAVINGSMETERHEADER: 'Emissions by category',
    CARBONKPIDETAILS: 'Carbon Emissions for',
    ENERGYUSAGEDETAILS: 'Energy Usage for',
    WATERUSAGEDETAILS: 'Water Usage for',
    CarbonSavingMeter: 'Savings by Utility',
    SITENAMESHEADER: 'Breakdown by sites',
    CARBONTOOLTIPHEADER: 'Carbon Emission',
    GASTOOLTIPHEADER: 'Energy Savings on Gas',
    ALLTOOLTIPHEADER: 'Energy Savings',
    METEROVERVIEW: 'Meter Overview',
    METERANALYSIS: 'Meter Analysis',
    ID: 'ID',
    TYPE: 'Type',
    DEVIATION: 'Deviation',
    HIGH: 'High({unit})',
    HIGHWITHOUTUNIT: 'High',
    LOW: 'Low({unit})',
    LOWWITHNOUNIT: 'Low',
    ENERGY: 'Energy({unit})',
    ENERGYNOUNIT: 'Energy',
    CHANGE: 'Change',
    CARBONTAB: 'Carbon (CO2e)',
    ENERGYTAB: 'Energy',
    WATERTAB: 'Water',
    EUITAB: 'EUI',
    UTILITYCOST: 'Utility',
    actualConsumption: 'ACTUAL CONSUMPTION',
    actualCons: 'ACTUAL CONS.',
    baselineConsumption: 'BASELINE CONSUMPTION',
    baselineCons: 'BASELINE CONS.',
    ConsumptionSavingsPercentage: '% CONS. SAVINGS',
    ConsumptionChange: 'CONS. CHANGE',
    ConsSavings: 'CONS. SAVINGS',
    utiltactualCost: 'ACTUAL COST',
    utilpreviousCost: 'PREVIOUS COST',
    SavingsPercentage: '% SAVINGS',
    utilchange: 'CHANGE',
    NODATA: 'No data',
    ENERGYKPIDETAILS: 'Electricity performance for',
    ENERGYPERFORMANCEALL: 'Energy Performance',
    NILMENERGYUSAGE: 'Energy Usage',
    NILMENERGYUSAGESUBHEADER:
      'The graph shows the energy consumption over the selected period',
    ALLKPICARDDETAILS: 'Energy performance for',
    WATERCONSUMPTIOND: 'Water Consumption for',
    ENERGYCONSUMPTIONMETER: 'Consumption by meter',
    WATERCONSUMPTION: 'Water Consumption',
    ALLUTILITIES: 'All Utilities',
    ALLEnergySources: 'All Energy Sources',
    WaterPerformance: 'Water Performance',
    WaterOverview: 'Water Overview',
    GASPERFORMANCE: 'Gas Performance for',
    GASPERFORMANCEDETAILS: 'Gas Performance',
    WATERPERFORMANCEDETAILS: 'Water Performance',
    SEWERAGEPERFORMANCE: 'Sewerage Performance',
    ALLSAVINGSBYUTILITY: 'BTU savings by Utility',
    TOTALENERGYCOST: 'Total Energy Cost',
    TOTALSAVINGS: 'Total Savings',
    TOTALFOOTSPRINT: 'Total Footprint',
    INTEGRATIONTYPE: 'INTEGRATION TYPE',
    UTILITYPROVIDER: 'UTILITY PROVIDER',
    ACCOUNTNUMBER: 'ACCOUNT NUMBER',
    STATUS: 'STATUS',
    UDSSTATUS: 'Monthly DS Status',
    IDSSTATUS: 'Interval DS Status',
    ACTIONS: 'ACTIONS',
    SERVICESOVERVIEW: 'Services Overview',
    AddService: 'ADD SERVICE',
    AllServices: 'All Services',
    Active: 'Active',
    Inactive: 'Inactive',
    Sewerage: 'Sewerage',
    ServiceProvider: 'Service Provider',
    AccountNumber: 'Account Number',
    CANCEL: 'CANCEL',
    SELECTALL: 'Select All',
    SEARCH: 'Search',
    SHOWACCOUNTNUMBERS: 'Show all Account Numbers',
    BACK: 'BACK',
    SUBMIT: 'SUBMIT',
    Complete: 'COMPLETE',
    DONE: 'DONE',
    Utillity: 'Utility',
    AllUtilityService: 'All Utility Service',
    Weather: 'Weather',
    WeatherServices: 'Weather Services',
    Weatherdata: 'Weather data can be integreated with linking your accounts',
    CONFIGURE: 'CONFIGURE',
    METERID: 'METER ID',
    SERVICETYPE: 'SERVICE TYPE',
    METERINGPURPOSE: 'METERING PURPOSE',
    SITESETTINGS: 'Site Settings',
    SERVICESINTEGRATION: 'Services',
    USERMANAGEMENT: 'User Management',
    GENERALSETTINGS: 'General Settings',
    UTILITYBILLTOOLTIPHEADER: 'Utility Bill',
    UTILITYBILLDETAILSTOOLTIPHEADER: 'Utility Performance',
    ELECTRICITYTOOLTIPHEADER: 'Energy Savings on Electricity',
    WATERTOOLTIPCONTENT:
      'Comparison of Water Consumption for the selected duration from actuals with respect to baseline year data',
    UTILITYBILLOVERVIEWTOOLTIPCONTENT:
      'Cost calculated for the selected duration from actuals with respect to previous year data. Note - The cost is calculated based on calendar months and not specific to Utility billing periods.',
    UTILITYBILLTOOLTIPCONTENT:
      'Usage and cost calculated for the selected duration from actuals with respect to previous year data. Note - The cost is calculated based on calendar months and not specific to Utility billing periods.',
    CARBONTOOLTIPCONTENT:
      'Emission calculated for the selected duration from actuals with respect to previous year data. ',
    DATANEEDEDCONTENT:
      'Scope 1 data missing, review and update data every month',
    CARBONTOOLTIPSECONDCONTENT:
      'Real-time CO2 calculations are based on the main meter, and precise carbon calculations are updated post utility bill generation.',
    CARBONTOOLTIPSUTILITY:
      'Emission calculated for the selected duration from actuals with respect to previous year data. Actual carbon emission calculations are based on utility bill provided.',
    CARBONTOOLTIPLIVE:
      'Emission calculated for the selected duration from actuals with respect to previous year data from the onsite meter. Real-time C02 calculations are based on the main meter.',
    CARBONTOOLTIPINTRVAL:
      'Emission calculated for the selected duration from actuals with respect to previous year data. Actual carbon emission calculations are based on utility interval data.',
    ELECTRICITYTOOLTIPCONTENT:
      'Savings for electricity calculated for the selected duration from actuals with respect to baseline year data',
    DATANEEDED1:
      'Insufficient data - Scope 1 data needs to be updated every month.',
    GASTOOLTIPCONTENT:
      'Savings for gas calculated for the selected duration from actuals with respect to baseline year data',
    ALLTOOLTIPCONTENT:
      ' Savings calculated for the selected duration from actuals with respect to baseline year data',

    UTILITYVIEWDETAILSTOOLTIP:
      'Usage and cost calculated for the selected duration from actuals with respect to previous year data. Note - The consumption and cost is calculated based on calendar months and not specific to Utility billing periods.',
    EMAASENERGYUSAGETOOLTIP:
      'Usage calculated for the selected duration from actuals with respect to baseline year data',
    EMAASENERGYUSAGETOOLTIPPREV:
      'Usage calculated for the selected duration from actuals with respect to previous year data',
    EMAASCONSUMPTIONTOOLTIP:
      'Usage calculated for the selected duration based on actuals compared to baseline or previous year data',
    EMAASWATEROVERVIEWTOOLTIP:
      'Usage calculated for the selected duration based on actuals compared to previous year data',
    EMAASNILMTOOLTIP:
      "Determine the breakdown of your site's energy consumption by the types of equipment",
    PORTFOLIOSUMMARYTOTALSAVINGSTOOLTIP:
      'Total cost savings from energy utilities for the selected duration',
    PORTFOLIOSUMMARYEUITOOLTIP:
      "EUI is an indicator of the energy efficiency of a building's design and/or operations. EUI is measured as energy aggregation of the portfolio divided by total Sqft of the portfolio in a year.",
    SITESUMMARYEUITOOLTIP:
      "EUI is an indicator of energy efficiency of a building's design and/or operations. EUI is measured as energy aggregation of the site for last 12 months divided by total gross area of the site.",
    PORTFOLIOSUMMARYEUITOOLTIPHEADER: 'EUI (Energy Use Intensity)',
    SUMMARYEUITOOLTIPHEADERFORSITE: 'EUI (Energy Use Intensity) - {date}',
    PROVIDERLISTPLACEHOLDER: 'Search for provider details',
    PORTFOLIOSUMMARYHEADER: 'Carbon and Energy Overview',
    PORTFOLIOSUMMARYHEADERLASTUPDATEDON: 'Last updated on {date}',
    AIModelDetails: 'AI Model Details',
    DATAUPLOAD: 'Data Upload',
    ADDFUEL: 'Add Fuel',
    ADD: 'Add',
    ADDCOMPOUND: 'Add Compound',
    ADDMETEREDGAS: 'Add Metered Gas',
    ADDSCOPETWO: 'Add Scope 2',
    EXCEEDEDLIMIT: 'exceeded max limit up to 4',
    DETAILS: 'Details',
    DATAUPLOADDETAILS:
      'Access all the features that require manual input / upload of data files',
    DATAUPLOADCECARDSUBTITLE:
      "Track the usage of scope 1 carbon emissions to meet your company's sustainability performance targets.",
    // DATAUPLOADCARBONESUBTITLE:'Access all your uploaded data files for weather, utility and point data.',
    DATAUPLOADCARBONESUBTITLE:
      'This page displays a comprehensive table showcasing various fuels, their corresponding quantities, and the associated carbon emission factors for the selected year.',
    SCOPEONETWOSUBTITLE:
      'This page presents a detailed table showing Scope 1 (Direct emissions, including Stationary Combustion and Refrigerants) and Scope 2 (Indirect emissions from Electricity) emissions, along with their quantities and associated carbon emission factors for the chosen year.',
    METERDATASUBHEADER: 'Access all your uploaded data files for meter data.',
    DATAMISSINGALERTS: 'Alerts for Data Missing',
    UPLOAD: 'Bulk Upload',
    UPLOADTOPADD: 'Upload File',
    PUBLISHFILE: 'Publish',
    BASELINEFILE: 'Baseline',
    BASELINE_SUCCESS: 'Baseline training initated successfully',
    UPLOADTOP: 'Upload',
    UPLOADFILE: 'UPLOAD',
    NAME: 'Name',
    DATATYPE: 'Data Type',
    CREATEDON: 'Created On',
    DATEOFUPLOAD: 'Date of upload',

    ALLUPLOADS: 'All Uploads',
    STATIONARYCOMBUSTION: 'Stationary Combustion',
    REFRIGERANTS: 'Refrigerants',
    WHEATHERDATA: 'Weather Data',
    UTILITYBILL: 'Utility Bill',
    SCOPE2: 'Scope 2',
    METEREDGAS: 'Metered Gas',
    NOFILESADDEDHEADER: 'There are no files added yet.',
    NOFILESADDEDMESSAGE:
      'Get started by uploading weather, utlity or point data',
    UPLOADBUTTON: 'UPLOAD',
    METER_DATA: 'Meter Data',
    UTILITY_BILL: 'Utility Bill',
    FUEL_NAME: 'FUEL NAME',
    SEARCHFOR: 'Search for',
    EnergyManagementSiteDashboardPortfolioTitle: 'Carbon And Energy Overview',
    CHOOSEDATATYPEMESSAGE:
      'Choose data type below to download the template and proceed next step to upload files.',
    UPLOADMETERDATASTEPONEMESSAGE: 'Step 1: Download Meter Data Template',
    UPLOADMETERDATA: 'Upload Meter Data',
    FILEUPLOADNOTE:
      'Note: Accepted only {type} file and each file should not exceed {size}mb.',
    UPDATEDFILEUPLOADNOTE:
      'Note: Accepted only CSV  file and the file should not exceed 5Mb',
    INSTRUCTIONSFORFILLINGTHETEMPLATE:
      'Instructions for uploading the template.',
    INSTRUCTIONTEMPLATEONE:
      'Start by uploading historical meter reading data using the provided CSV template.',
    INSTRUCTIONTEMPLATEONEPOINTFIVE:
      'Please ensure that uploaded data values are in the unit configured in RBM against the meters',
    INSTRUCTIONTEMPLATEFIVE:
      'User can upload maximum 10 files during the upload process, with a total combined file size not exceeding 1.5GB.',
    INSTRUCTIONTEMPLATETWO:
      'User can upload data maximum 2 year worth of data with 1, 3, 5 or 15mins interval of file size upto 1.5gb',
    INSTRUCTIONTEMPLATETHREE:
      'Please note dashboard and reports will display the historical meter data for the last 15 days and all meter data uploaded will be utilized to train a good quality baseline model',
    INSTRUCTIONTEMPLATEFOUR: 'View example of filled CSV template',
    UPLOAD_PROGRESS_IN_TOAST:
      'Upload progress can be seen in the Widget at bottom of the screen.',
    PUBLISHMODALHEADER: 'Ready to publish?',
    ERRORINPUBLISHING:
      'Some error occurred in publishing the files. Please retry in some time',
    WARNINGNOTIFICATIONFORPUBLISH:
      'Additional files are currently being uploaded',
    WARNINGINSTRUCTIONFORPUBLISHFILE:
      'Would you prefer to wait before publishing or continue to publish {filesToPublish} files?',
    NOTEFORPUBLISHFILE:
      'Note: We will notify you via email once the publish is completed, and will display the historical meter data only for the past 15 days in dashboard/reports.',
    INSTRUCTIONFORPUBLISHFILE: 'Would you like to publish the uploaded files?',
    DOWNLOAD_METER_DATA_CSV_TEMPLATE: 'Download Meter Data CSV Template',
    PUBLISHBUTTON: 'Yes, Publish',
    METERDATAPUBLISHINGMSG:
      'Please hold while we publish the data, and we will notify you via email once it’s completed.',
    METERDATAUPLOADFAILED:
      'Upload failed for file: {fileName}. Please try again in some time',
    METERDATAUPLOADSUCCESS: 'File: {fileName} uploaded successfully',
    NOBUTTON: 'No',
    METERUPLOADINSTRUCTIONTITLE: 'Instructions for uploading meter data',
    METERUPLOADDOWNLOADCSV: 'Download CSV Template',
    METERUPLOADDOWNLOADEXCEL: ' Download CSV Template',
    METERUPLOADINSTRUCTIONONE:
      'Start by uploading historical meter reading data using the provided CSV template. ',
    METERUPLOADINSTRUCTIONFOUR:
      'Ensure the downloaded data from supervisor does not exceed 1.5GB. Please refer to the provided for data size preferences. ',
    METERDATAEXCELDOWNLOAD: 'Download Estimation Excel',
    METERUPLOADINSTRUCTIONTWO:
      'After uploading CSV files for all/desired site meters, click the "Publish" button to process and backfill historical data.',
    METERUPLOADINSTRUCTIONTHREE:
      'To establish a baseline, click the "Baseline action" and specify the desired data range, and Forge AI will train the baseline using available historical data published.',
    CHOOSEDATATYPE: 'Choose Data Type',
    NEXTUPLOAD: 'Next-Upload',
    UPLOADDATA: 'Upload Data',
    ADDNEWFUEL: 'Add new Fuel to',
    ADDNEWCOMPOUND: 'Add new Compound to',
    MANUALINPUT: 'MANUAL INPUT',
    UPLOADDATACAPS: 'UPLOAD DATA',
    ADDNEWFUELSUB:
      'Choose from below options to manually input or upload template',
    SCOPEONESC: 'Stationary Combustion : Add  Fuel',
    SCOEONEREF: 'Refrigerants : Add  Compound',
    SCOPETWO: 'Scope 2',
    UPLOADING: 'Uploading',
    FILES: 'files',
    FILE: 'file',
    UPLOADINGMESSAGE1:
      'The upload progress and status information for these files are visible     in the toast notification located at the bottom center of the screen.',
    REDIRECTMESSAGE1: 'You will be redirected in',
    REDIRECTMESSAGE1OCR: 'You will be redirected soon',
    REDIRECTMESSAGE2: 'sec.',
    UPLOADFILES: 'Upload files for',
    UPLOADMETERDATASTEPTWOMESSAGE: 'Step 2: Upload files for Meter Data',
    UPLOADNOTE:
      'Accepted only {type} file and each file should not exceed {size}mb',
    UPDATEDUPLOADNOTE:
      'Accepted only one CSV file and the file should not exceed 1.5gb',
    UPDATEDUPLOADNOTESUB: '(only one upload possible at a time)',
    INSTRUCTIONBUTTON: 'example of filled CSV template',
    FILEUPLOADPLACEHOLDER: 'Drag and drop files here',
    SINGLEFILEUPLOADPLACEHOLDER: 'Drag and drop file here',
    TOTALSIZEEXCEEDSERROR: 'Total size exceeds the limit (1.5GB)',
    NUMBEROFFILEALLOWED: 'You can upload up to 10 files',
    FILEUPLOADPLACEHOLDERONLYONEFILE: '(only one upload possible at a time)',
    REMOVE: 'Remove',
    CHOOSESERVICE: 'Choose Service',
    CONNECT: 'Connect',
    NEXT: 'Next',
    CHOOSEUTILITYTYPE:
      'Select Utility service provider, credentials and account details to integrate data.',
    CHOOSEUTILITYTYPEMANUAL:
      'Enter Utility service provider and account details to upload utility data manually.',
    EDITDETAILNOTE:
      'Enter the correct account and meter details below. Then, click on "Submit" to update and save them.',
    EDITDETAILWHENBILLEXISTS:
      'Enter the correct account and meter details below. Then, click on "Submit" to update and save them.',
    SEARCHPROVIDER: 'Search Utility provider',
    CONTACTSUPPORT:
      'Can’t find the Utility provider? Please contact Honeywell support.',
    UTILITYPROVIDERLABEL: 'Utility Provider',
    SERVICEPROVIDERNAME: 'SERVICE PROVIDER',
    INTEGRATIONTYPENAME: 'INTEGRATION TYPE',
    UTILITYSERVICES: 'Utility Services',
    UtilityHandoffNotification:
      "The integration type of {manualCount} Utility Service Account can be converted from 'Manual' to 'Automated'. This will enable Automatic updating of utility bills without any actions needed from you. Find the option under the 'Actions' menu in the table below.",
    UTILITYSERVICESDETAILS:
      'Integrate and manage your multiple services to avail data automatically fast and smart.',
    ADDUTILITYSERVICE: 'Add Utility Service',
    ADDUTILITYTYPE: 'Utility Integration Type',
    AUTOMATEDTEXT:
      'Please provide your credentials for the "Utility Provider" account to enable automatic monthly retrieval of your utility bill data.',
    MANUALTEXT:
      'If you don’t have credentials for your service provider and you need to update your utility bill information manually every month.',
    MANUAL: 'Manual',
    AUTOMATED: 'Automated',
    ADD_UTILITY_SERVICE: 'Add Utility Service',
    UITLITYTYPES: 'UTILITY TYPES',
    NOACCOUNTADDEDHEADER: 'There are no Utility Accounts added yet.',
    NOACCOUNTADDEDMESSAGE:
      'Get started by integrating accounts to manage bills and tariffs',
    ADDACCOUNTNUMBER: 'Add',
    SELECTUTILITY: 'Select a Utility',
    ACCNUMBER: 'Account number*',
    UTILITYPROVIDERERROR:
      'Utility provider not found. Please contact your Honeywell Manager for Assistance in converting this account',
    PASSWORD: 'Password*',
    USERNAME: 'Username*',
    SIGNIN: 'Signin',
    UTILITYPROVIDERTOOLTIPTXT:
      'Enter the name of the Utility Provider as mentioned on the Utility Bill.',
    VERIFICATIONINPROCESS: 'Verification in process',
    VERIFICATIONMSSG1: 'Account verification process takes 2/3 days.',
    UPDATECREDENTIALS: 'Update Credentials',
    UPDATECREDENTIALSNOTE:
      'Please enter your updated “Service Provider Name” password to activate your account.',
    ENTERCREDENTIALS: 'Enter Credentials',
    ENTERCREDENTIALSNOTE:
      'Please use your “Service Provider Name” credentials to link the account.',
    PLEASEUSESERVICE:
      'Please use your "Service Provider" credentials to link the account.',
    FILEEMPTYERRORMSG: 'Error! The file is empty, please upload again.',
    FILESIZEERRORMSG:
      'The file size exceeds 50mb. Please reduce the file size and try again.',
    FILEMAXSIZEERRORMSG:
      'The file size exceeds {maxSize}. Please reduce the file size and try again.',
    FILEHEADERERROR:
      'The file has invalid headers. Please use the provided template and upload again.',
    CSVFILEINVALID:
      'The uploaded CSV file data/name is invalid. Please check file and try again.',
    CSVFILEINVALIDNAME:
      'The uploaded CSV file is invalid. Any special char or multiple extention is not alloed.',
    DEACTIVATEACCOUNT: 'Deactivate account',
    DEACTIVATEUDSACCOUNT: 'Deactivate Monthly Data Service',
    DEACTIVATEIDSACCOUNT: 'Deactivate IDS (Interval Data Service)',
    REACTIVATEACCOUNT: 'Reactivate account',
    REACTIVATEIDSACCOUNT: 'Reactivate IDS (Interval Data Service)',
    CONVERTTOAUTOMATIC: "Convert to 'Automatic'",
    MANAGEBILLDETAILS: 'Manage Bill Details',
    MANAGETARIFFDETAILS: 'Manage Tariffs',
    EDITACCOUNTDETAILS: 'Edit Account Details',
    EDIT_ACCOUNT_DETAILS: 'Edit Account Details',
    ADD_METERS: 'Add Meters',
    UTILITY_TYPES: 'UTILITY TYPES',
    CONVERT_INTEGRATION_TYPE: 'Convert Integration Type',
    ACCOUNT_NUMBER: 'Account Number',
    BILLING_CYCLE: 'Billing Cycle',
    PERIOD: 'Period',
    EDITACCOUNTDETAILSTOOLTIP:
      'User is allowed to edit all the fields in case there are no bills uploaded.',
    EDITACCOUNTDETAILSTOOLTIPFORAUTOMATIC:
      'User is allowed to edit the Account number',
    CONVERTINTRGRATIONTYPE: `Convert to 'Automatic'`,
    ENABLEIDS: 'Enable IDS (Interval Data Service)',
    DELETE: 'Delete',
    DELETING: 'Deleting',
    DEACTIVATECONFIRMATIONNOTE:
      'Are you sure you want to deactivate Account Number',
    DEACTIVATEIDSCONFIRMATIONNOTE:
      'Are you sure you want to deactivate IDS (Interval Data Service) for Account Number',
    REACTIVATECONFIRMATIONNOTE:
      'Are you sure you want to Reactivate Account Number',
    REACTIVATEIDSCONFIRMATIONNOTE:
      'Are you sure you want to Reactivate IDS (Interval Data Service) for Account Number',
    DEACTIVATEUTILITYACCOUNTMSSG:
      'Once the account is deactivated, application will not auto fetch the utility bill information and only the historical information will be stored.',
    DEACTIVATEIDSACCOUNTMSSG:
      'Once IDS is deactivated, application will not auto fetch the utility interval data and only the historical data will be stored.',
    REACTIVATEUTILITYACCOUNTMSSG:
      'Once the account is reactivated, application will auto fetch the utility bill information.',
    REACTIVATEIDSUTILITYACCOUNTMSSG:
      'Once the account is reactivated, application will auto fetch the utility interval data.',
    YES: 'Yes',
    NO: 'No',
    REVERIFYNOTE:
      'Please enter your “Service Provider” credentials to link the account.',
    REVERIFYHEADER: 'Verify Credentials and Account Number',
    REVERIFY: 'Reverify',
    UPDATE: 'Update',
    REENROLL: 'Reactivate account',
    save: 'SAVE',
    ACCOUNTMISSINGHEADER: 'Update Account Number',
    ACCOUNTMISSINGNOTE:
      'Please enter your “Service Provider” credentials and account Number to link the account.',
    SHOWMORE: 'Show More',
    NORESULTS: 'No results found.',
    BREAKDOWNBYSITE: 'Breakdown by Site ({count})',
    PORTFOLIOENERGY: 'Energy',
    PORTFOLIOENERGYCONS: 'Energy Cons.',
    PORTFOLIOCONSUMTION: 'Consumption',
    PORTFOLIOWATER: 'Water',
    PORTFOLIOWATERCONS: 'Water Cons.',
    ENERGYUSAGEBYSITE: 'Energy Usage By Sites ({count})',
    SITEWITHDATA: '* Only sites with data are shown in the table',
    ELECTRICITYUSAGEBYSITE: 'Electricity Usage By Sites ({count})',
    GASUSAGEBYSITE: 'Gas Usage By Sites ({count})',
    WATERUSAGEBYSITE: 'Water Usage By Sites ({count})',
    ENERGYOPTIMIZATION: 'Energy Optimization',
    ENERGYOPTIMIZATIONNEW: 'Energy Optimization',
    ENERGYOPTIMIZATIONEO: 'Energy Optimization (EO)',
    ENERGYOPTIMIZATIONSAVINGS: 'EO Summary',
    EOSETTINGSUBTITLE:
      'EO continuously monitors, measures and optimizes HVAC in building for lowest energy consumption in all situations, minimizing the energy spent in heating and cooling of a facility and continuously.',
    EOSETTINGMODALHEADER: 'Inactive Energy Optimization?',
    EOSETINGMODALCONTENT:
      'Energy Optimization will not continuously monitors, measures and optimizes HVAC in your facility for lowest energy consumption.',
    EOSETINGMODALCONTENTSUB:
      'Are you sure you want to Inactivate Energy Optimization ?',
    EOENABLETITLE: 'Enable energy optimization for this site.',
    EOSTATUSMESSAGESUCCESS:
      'Energy Optimization enabled for this site successfully.',
    EOSTATUSMESSAGEERROR:
      'Energy Optimization disabled for this site successfully.',
    EOSETTINGNODATAAVAILABLE:
      'Please contact system administrator, configuration is not complete.',
    CURRENTEOSTATUS: 'Current EO Status: ',
    ON: 'On',
    OFFMANUALSWITCHEDOFF: 'Off-Manual Switched Off',
    OFFLINE: 'Offline',
    EONotOptimizing: 'EO Not Optimizing',
    OFFPLANNEDOFFFORIMPROVINGBASELINE: 'Planned Off for Improving Baseline',
    SwitchedOfffromCloud: 'Switched Off from Cloud',
    SwitchedOfffromSite: 'Switched Off from Site',
    EOON: 'EO On status indicates current optimization strategy in use',
    EOMANUALSWITHCHEDOFF:
      'set-point has not been applied since EO was switched off manually',
    PLANNEDOFFFORBASELINE:
      'EO is planned off to collect data for baseline improvement',
    STATUSNOTAVAILABLE: 'Status not available',
    STATUSNOTAVAILABLETOOLTIP:
      'Status details are not present at this time. Please contact the Honeywell support team - connectedbuildingsupport@honeywell.com to resolve this condition',
    EOOFFLINE:
      'EO Not Optimizing status indicates optimization strategy not in use due to optimization failure',
    SwitchedOfffromCloudToolTip:
      'EO is manually switched off from cloud.Please contact connectedbuildingsupport@honeywell.com to switch on the EO',
    SwitchedOfffromSiiteToolTip:
      'EO is switched off manually by the user from site',

    EOSavings: ' Energy Optimization Savings',
    EOUtility_all: 'All Utilities',
    EOUtility_electricity: 'Electricity',
    EOUtility_gas: 'Gas',
    EOUtility_steam: 'Steam',
    EOUtility_chilledwater: 'Chilled Water',
    EOUtility_hotwater: 'Hot Water',
    inactiveDays: 'Inactive Days',
    inactiveDay: 'Inactive Day',
    excludedDays: 'Excluded Days',
    excludedDay: 'Excluded Day',
    activeHours: 'Active Hours',
    activeDay: 'Active Day',
    savingsSummaryEO:
      'Estimated Savings (With {opertionalPercentage}% EO Operational Time)',
    operationalTimeEO: 'With {opertionalPercentage}% EO Operational Time',
    timeUsedForBaselining: '{baseline}% time used for baselining',
    siteComfort: 'Site Comfort',
    activeStrategyStatus: 'Active',
    // CURRENTEOSTATUS: 'Current EO Status: ',
    // ON: 'On',
    // OFFMANUALSWITCHEDOFF: 'Off-Manual Switched Off',
    // OFFLINE: 'Offline',
    // OFFPLANNEDOFFFORIMPROVINGBASELINE: 'Off-Planned Off for Improving Baseline',
    // EOON: 'EO On status indicates current optimization strategy in use',
    // EOMANUALSWITHCHEDOFF:
    //   'set-point has not been applied since EO was switched off manually',
    // PLANNEDOFFFORBASELINE: 'EO is planned off for baseline improvement',
    // EOOFFLINE:
    //   'EO Off status indicates optimization strategy not in use due to optimization failure',
    inactiveStrategyStatus: 'Inactive',
    lastUpdated: 'Last Updated:',
    CALCULATED: 'Baseline',
    ESTIMATEDSAVINGS: 'Estimated Savings',
    OPPORTUNITYFROMEO: 'Opportunity from EO',
    EMAASEOSTATETOOLTIP:
      'Active or inactive status indicates the current optimization strategy in use.',
    EOSAVINGTOOLTIP:
      'Energy savings when Energy Optimization was run compared to calculated energy usage.',
    EOSAVINGONENABLE: 'Savings on EO enabled days',
    EOSAVINGENTIREPERIOD: 'Savings over the entire period',
    EONEGATIVEORZEROSAVINGSMESSAGE:
      'No savings within the selected time range. To know the estimated savings, consider expanding the selected duration to a longer period.',
    EMAASPORTFOLIOENERGYUSAGETOOLTIP:
      'Usage calculated for the selected duration from actuals with respect to baseline year data. EUI is calculated using energy data from Utility bills.',
    EMAASPORTFOLIOENERGYUSAGETOOLTIPPREV:
      'Usage calculated for the selected duration from actuals with respect to previous year data. EUI is calculated using energy data from Utility bills.',
    EMAASPORTFOLIOCONSUMPTIONTOOLTIP:
      'Usage calculated for the selected duration based on actuals compared to baseline or previous year data. EUI is calculated using energy data from Utility bills.',
    CEMSPORTFOLIO_UTIL_LIVE_CONSUMP_TOOLTIP:
      'Usage is calculated for the selected period from actuals, compared to previous or baseline data for utility and live meter respectively. Monthly usage is based on average daily energy from utility bills, normalized for full months when spanning two months.',
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_TOOLTIP:
      'Usage is calculated for the selected period from the actual, compared to baseline data from onsite meter.',
    CEMSPORTFOLIO_DATA_SOURCE_INTERVAL_TOOLTIP:
      'Usage is calculated for the selected period from the actual, compared to baseline data from utility interval data.',
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_WATER_TOOLTIP:
      'Usage is calculated for the selected period from the actual, compared to previous data from onsite meter.',
    CEMSPORTFOLIO_DATA_SOURCE_UTIL_TOOLTIP:
      'Usage is calculated for the selected period from the actual, compared to previous period data from utility bills. Monthly usage is based on average daily energy from utility bills, normalized for full month when bill spanning two months.',
    PORTFOLIOEUI: 'EUI ({unit})',
    PORTFOLIOWATERChange: 'Change',
    PORTFOLIOSITECOUNT: 'Breakdown by Site ({count})',
    UTILITYCOSTBYSITES: '{Utility} Cost by Sites ({count})',
    ALLUTILITYCOSTBYSITES: 'Utility Cost by Sites ({count})',
    SOLAR: 'Solar',
    WIND: 'Wind',
    SOLARPERFORMANCE: 'Solar Performance',
    WINDPERFORMANCE: 'Wind Performance',
    UTILITYCOSTOVERVIEW: 'Utility Cost Overview',
    DESCRIPTIONNOTIFICATION:
      'You have reached maximum number of utility accounts for same utility type. Contact your admin for creating more accounts.',
    TITLENOTIFICATION: 'Accounts limit reached.',
    ENERGYUSAGECAPS: 'ENERGY USAGE',
    UPDATEERRORMESSAGE: 'Something went wrong. Please try again later.',
    MANUALTOAUTOMATICCONVERSION:
      'Account conversion from Manual to Automatic is initaited successfully.',
    APPLY: 'APPLY',
    RESET: 'RESET',
    CLOSE: 'CLOSE',
    SCOPE1FUELTYPES: 'Scope 1 Fuel Types',
    SCOPE1FILTERSUBHEADER: 'Filter changes graphical view only',
    SCOPE1DATAMISSING: 'Scope 1 Data Missing',
    SCOPE1SHOWMISSINGDATA: 'Please review the scope 1 missing data and update',
    FUELGASTYPE: 'Fuel / Gas Type',
    COMPOUNDTYPE: 'Compound Type',
    UTILITYTYPE: 'Utility Type',
    FUELGASTYPESELECT: 'Select a Fuel / Gas Type',
    COMPOUNDSELECT: 'Select Compound Type',
    UTILITYSELECT: 'Select Utility Type',
    EMISSIONFACTOR: 'CO2 Emission Factor',
    SelectCategory: 'Select Category',
    UNIT: 'Unit',
    UNITSELECT: 'Select a Unit',
    StationaryCombustion: 'Stationary Combustion',
    YEAR: 'Year',
    Country: 'Country',
    State: 'State',
    YEARSELECT: 'Select a Year',
    MONTH: 'Month',
    Override: 'Override',
    MONTHSELECT: 'Select a Month',
    ADDDATA: 'Add Data',
    NOFUELCONSUMED: 'No Fuel Consumed ',
    NOCONSUMED: 'No Consumption',
    QUANTITY: 'Quantity',
    QUANTITYENTER: 'Enter Quantity',
    COSTSCOPE: 'Cost',
    COSTENTER: 'Enter Cost',
    EDIT: 'Edit',
    YEARCHECK: 'year',
    MONTHERROR: 'Select Different Month',
    SUCCESS: 'Data updated successfully',
    CO2FACTORROOLTIPHEADER: 'CO2 Emission Factor',
    PLEASENOTE: 'Please Note: ',
    PLEASENOTETEXT:
      'The new carbon emissions factor will be used in the next carbon emissions calculation. Already calculated carbon emissions values would not be recalculate using the new value.',
    CO2FACTORROOLTIPCONTENT:
      'It is the quantity of CO2 released to the atmosphere per unit of energy used',
    CO2FACTORSCCONTENT:
      'It is the quantity of CO2 released to the atmosphere per unit of energy used. Enter the value equivalent in kgCo2e/mmbtu for selected unit.',
    CO2FACTORRFCONTENT:
      'It is the quantity of CO2 released to the atmosphere per unit of energy used. Enter the value equivalent in MTCo2e/mmbtu for selected unit.',
    CO2FACTORSCOPETWOANDGASCONTENT:
      'It is the quantity of CO2 released to the atmosphere per unit of energy used. Enter the value equivalent for the selected unit.',
    FUELTABLETEXT: 'Below Fuel Types belong to Scope 1 Emissions',
    METEREDGASHEADER: 'Below Utility Types belong to Scope 1 Emissions',
    SCOPETWOHEADER: 'Below Utility Types belong to Scope 2 Emissions',
    UNITDROPDOWNNAME: 'Unit',
    COMPOUNDTABLETEXT: 'Below Compound Types belong to Scope 1 Emissions',
    ENERGYCONSUMPTIONNILM: 'Energy Consumption',
    ENERGYCONSUMPTIONSECONDHEADERNILM:
      'The graph shows the energy consumption and its breakdown over the selected period',
    ENERGYCONSUMPTIONBYEQUIPMENTTYPE: 'Energy consumption by Equipment Type',
    METERNAME: 'Meter Name*',
    METERNUMBER: 'Meter Number*',
    CONSUMPTIONUNIT: 'Consumption Unit',
    DEMANDUNIT: 'Demand Unit',
    CURRENCYUNIT: 'Currency Unit',
    TOTALMETERS: 'TOTAL METERS',
    METERNAMECHANGEDESCRIPTION:
      "Below are the list of meter ID's associated with the account",
    METERNAMEUPDATESUCCESS:
      'Meter ID: ({meterId}) has been named successfully to "({meterName})"',
    METERNAMECHARACTERS: 'Use alpha-numeric characters only',
    METERNAMEMAXLENGTH: 'Max Lenth: {maxCh} Characters',
    NILMDROPDOWNALLMETERS: '',
    BILLBREAKDOWN_OVERVIEW: 'Consumption Overview ({rate})',
    DEMAND_OVERVIEW: 'Demand Overview {rate}',
    DEMAND: 'Demand',
    CONSUMPTION_RATE_OVERVIEW: '{name} Overview ({rate})',
    ELECTRICITYBLENDEDRATE: 'Blended Electricity Rate ({rate})',
    BILLBREAKDOWN_COST_OVERVIEW: '{utilityName} Cost Overview ({rate})',
    BILLBREAKDOWN_COST_TOOLTIP_HEADER: 'Electricity cost ({rate})',
    COST: 'Consumption Overview',
    SUMMARY: 'Summary',
    PDF: 'PDF',
    MANAGE_COLUMNS: 'Manage Columns',
    RESET_ALL_FILTERS: 'Reset all filters',
    DOWNLOAD_CSV: 'Download CSV',
    DOWNLOAD_PDF: 'View & Download PDF',
    UTILITY_BILL_ANALYSIS: '{utilityName} Bill Analysis',
    NOTIFICATIONBOXFORMONTHLY:
      'Electricity bill analysis comes with Monthly and Billing period views.  Monthly view calculates utility bill from the start to the end of the month on pro-data basis. Example ( 01 May, 2022- 31 May, 2022). Whereas Billing period view calculates the utility bill as per actual billing cycle. Example (22 May, 2022- 22 June, 2022). Click on the billing period to view data as per actual billing cycle.',
    SUMMARYTABLEAPIONGOING:
      'Summary table calls are being processed batchwise, please click after all the table data are loaded.',
    NOTIFICATIONFORBILLINGPERIOD:
      'Billing period view calculates the utility bill as per actual billing cycle. Example (22 May, 2022- 22 Jun, 2022).',
    VIEW_OVERVIEW: 'View Overview',
    FILE_DELETED_SUCCESSFULLY: 'File deleted successfully',
    FILE_DELETEING_ERROR:
      'Error in deleting the file. Please try again in some time.',
    AVG_CONSUMP_PER_MTH: 'Avg. Consumption per month',
    AVG_CONSUMP_PER_DAY: 'Avg. Consumption per day',
    MTHLY_CONSUMP_PER_SQFT: 'Monthly Consumption per sq. ft.',
    EnableIDSText:
      'Enter the credenatials to verify the account. Click on submit to enable IDS.',
    EnableIDSHeaderTxt: 'Enable IDS (Interval Data Service)',
    EOSAVINGS: 'EO Savings',
    EOSUMMARY: 'EO Summary',
    REASONFOROFFLINE: 'Reason for Off - Details'
  },
  alarmConfiguration: {
    ALARMTYPE: 'Alarm Type',
    CONFIGUREALARMDESCLINE1: 'Select the Alarm type for meters to configure',
    CONFIGUREALARMDESCLINE2:
      'Select the alarm type for meters to raise alarms, if energy consumption goes over baseline at the mentioned range.',
    ALLMETERS: 'All Meters ',
    SEARCHALARMTYPE: 'Select the Alarm Type',
    SEARCHMETERS: 'Search Meter',
    THRESHOLDSETTINGS: 'THRESHOLD SETTINGS',
    NOMETERSSELECTED:
      'Select minimum one or more meters on the left\npanel to change threshold values.',
    THRESHOLDALARM: 'THRESHOLD ALARM',
    ALARMNAME: 'Alarm Name',
    MINTHRESHOLD: 'Min Threshold',
    MAXTHRESHOLD: 'Max Threshold',
    TO: 'to',
    RESETTODEFAULTS: 'Reset to defaults',
    SAVE: 'SAVE',
    NOMETERSUNDERSITE: 'No meters available',
    NOSITESAVAILABLE: 'No sites available',
    VALIDATIONREQUIRED:
      'Atleast one priority must be selected and all inputs under it must be filled',
    VALIDATIONOVERLAPPING:
      'The entered data is either invalid or overlapping with other values'
  },
  urjanetStatus: {
    ENROLLED: 'Successfully Enrolled',
    ENROLLEDMSG: 'Extraction of account was successful',
    SUCCESSFUL_DELIVERED: 'Successfully Delivered',
    SUCCESSFUL_DELIVEREDMSG:
      'Extraction and delivery of account were successful',
    PRODUCTION: 'Production',
    PRODUCTIONMSG: 'Account is in production',
    Active: 'Active',
    ACTIVEMSG: 'Manual account exist and user is allow to enter manual bills.',
    Enroll_Successful: 'Enroll_Successful',
    FAILEDLOGIN: 'Failed Login',
    NEEDSCREDENTIAL: 'Needs Credential',
    NEEDSCREDENTIALMSG: 'Account does not have a credential associated with it',
    FAILEDTOACCESS: 'Failed to Access',
    NEEDSTEMPLATE: 'Needs Template',
    NEEDSTEMPLATEMSG:
      'Account has a credential but that credential does not have an assigned template',
    UNDERREVIEW: 'Under Review',
    UNDERREVIEWMSG: 'Failing with generic status',
    WEBSITEISSUE: 'Website Issue',
    WEBSITEISSUEMSG: 'The account is failing to connect with the website',
    CAPTCHALOGIN: 'Captcha Login',
    CAPTCHALOGINMSG: 'Login is blocked by Captcha on the website',
    TEMPLATEFAILURE: 'Template Failure',
    TEMPLATEFAILUREMSG:
      'An issue with the template prevented successful extraction',
    NEEDSENROLLMENT: 'Needs Enrollment',
    NEEDSENROLLMENTMSG: 'Account needs to be enrolled',
    NOBILL: 'No Bill',
    NOBILLMSG: 'The account has no bill available on the website',
    REENROLLED: 'Re Enrolled',
    REENROLLEDMSG: 'Account is enrolled again after Deactivation',
    NAVIGATIONFAILURE: 'Navigation Failure',
    NAVIGATIONFAILUREMSG: 'Template fix required for these accounts',
    SOURCEFORMATCHANGE: 'Source_Format Change',
    SOURCEFORMATCHANGEMSG: 'A new bill format has been detected',
    ACCOUNTNUMBERCHANGE: 'Account_Number Change',
    ACCOUNTNUMBERCHANGEMSG: 'The account number changed to the new one',
    USERACTIONREQUIRED: 'User_Action Required',
    USERACTIONREQUIREDMSG: 'Action required from Customer',
    MIGRATION: 'Migration',
    MIGRATIONMSG: 'Account migrated with new provider/account number',
    INITIALTEMPLATEDEVELOPMENT: 'Initial_Template Development',
    INITIALTEMPLATEDEVELOPMENTMSG: 'The template is under development',
    REJECTED: 'Rejected',
    REJECTEDMSG: 'Accounts rejected since these are not valid to process',
    EBILLENROLLMENT: 'Ebill Enrollment',
    EBILLENROLLMENTMSG:
      'Account for which e-bill enrollment is required/pending',
    CREDENTIALUPDATED: 'Credential Updated',
    CREDENTIALUPDATEDMSG:
      'The credentials have been updated after failing, Account verification process takes 2/3 days.',
    TEMPLATEUPDATED: 'Template Updated',
    TEMPLATEUPDATEDMSG: 'The template has been updated but has not been tested',
    UNKNOWN: 'Unknown',
    UNKNOWNMSG: 'Account status is unknown',
    PENDINGMSG: 'Accunt status is pending',
    PENDING: 'Pending',
    DELETED: 'Deleted',
    DELETEDMSG: 'The Account has been deleted',
    ENROLLMENTFAILUREMSG: 'Failure in enrolling account',
    ENROLLMENTFAILURE: 'Enrollment Failure',
    DOESNOTEXIST: 'Does_Not Exist',
    DOESNOTEXISTMSG: 'Accunt does not exist',
    ACCOUNTNUMBERMISMATCHMSG: 'Account number mismatch',
    ACCOUNTNUMBERMISMATCH: 'Account_Number Mismatch',
    CONVERSIONINPROGRESS: 'Conversion In Progress',
    CONVERSIONINPROGRESSMSG:
      'Account Conversion in progress from manual to automatic',

    FAILEDTOACCESSMSG:
      'Extraction returned nothing (could be new website or broken navigation)',
    FAILEDTOACCESSMSGIDS: 'Failed to access utility interval data',
    FAILEDLOGINMESSAGE:
      'The navigation failed at the login step specifically (check user/password)',
    ACCOUNTMISSING: 'Account Missing',
    ACCOUNTMISSINGMESSAGE:
      'The credential ran and succeeded in some capacity, but there was no trace of this account',
    CONNECTIONERROR: 'Connectivity Error',
    CONNECTIONERRORMESSAGE:
      'Something went wrong, please reenter the “Service Provider” credentails for the account.',
    CONNECTIONERRORMESSAGEIDS: 'Something went wrong.',
    BLOCKED: 'Account Blocked',
    BLOCKEDMESSAGE: 'Login Blocked.',
    INACTIVE: 'Account Inactive',
    INACTIVEMESSAGE: 'The account is inactive.',
    FINALLED: 'Account closed',
    FINALLEDMESSAGE:
      'Review account and unsubscribe the account if it no longer needs to be processed.',
    VERIFICATIONINPROG: 'Verification in progress',
    VERIFICATIONINPROGIDS: 'Activation in progress',
    REENROLLMENTPROG: 'Re-Enrollment in progress',
    REACTIVATIONPROG: 'Reactivation in progress',
    SUBMITTED: 'Submitted',
    SUBMITTEDMSG: 'Initial state of account; should automatically proceed',
    NOMINATEDPROG: 'Nominated',
    METERSMISMATCHED: 'MetersMismatch',
    METERSMISMATCHEDMSG:
      'Meter details are not matching, Please update in Edit Account Details.',
    VERIFICATIONINPROGMESSAGE: 'Account verification process takes 2/3 days.',
    VERIFICATIONINPROGMESSAGEIDS:
      'Account verification process takes 2/3 days.',
    REENROLLMENTTOOLTIP:
      'Re-Enrollment action on this account is initiated again after Deactivation',
    REACTIVATIONTOOLTIP:
      'Reactivation action on this IDS account is initiated again after Deactivation',
    NOMINATEDMESSAGE:
      'Account has a fully provisioned credential which has not yet been run',
    DATAUNAVAILABLE: 'Statement Failed',
    STATEMENTMISSING: 'Statement Missing',
    DATAUNAVAILABLEMESSAGE:
      ' A statement was extracted, but was not persisted because of audit failures, storage failures, etc.',
    STATEMENTMISSINGMSG:
      'The credential ran and succeeded, and the account was seen on the website, but we were unable to extract a statement',
    NOTENROLLED: 'Not Enrolled',
    NOTENROLLEDMESSAGE:
      'Extraction of account was successful, but the account in question is not subscribed',
    DEACTIVATED: 'Deactivated',
    DEACTIVATEDMESSAGE: 'Account is no longer active.',
    REVIEWACCOUNTANDUNS:
      'Review account and unsubscribe the account if it no longer needs to be processed',
    ERROR: 'Error',
    ERRORMESSAGE:
      'Something went wrong. Please connect with your administrator.',
    LOGINFAILURE: 'Login Failure',
    LOGINFAILUREMESSAGE:
      'Login is failed due to password change or expiry for the service provider account.',
    DEACTIVATIONINITIATEDMSSG: 'Deactivation initiated.',
    DEACTIVATIONINITIATED: 'Deactivation in progress',
    REENROLLEDREQUIRED: 'Re Enroll Required',
    REENROLLEDREQUIREDMSG:
      'Re Enrollment is required for the account. Please Enter the credentials again by clicking on update.',
    ENABLEIDSMSG: 'IDS (Interval Data Service) has been enabled successfully.',
    INTERVALSNOTSUPPORTED: 'Not Supported',
    INTERVALSNOTSUPPORTEDMSG:
      'IDS is not supported by the utility provider for this account.',
    PLUGNEWACCOUNTMSG: 'Account enrolled successfully',
    PLUGEMAILAPPROVALMSG:
      'Account verification in progress and Arcadia requires email approval from customer',
    PLUGCREDENTIALISSUEMSG:
      'Failed to access utility interval data due to credential issue',
    PLUGNODATAAVAILABLEMSG:
      'Failed to access utility interval data as no data available',
    PLUGUNSUCCESSFULEMAILAPPROVALMSG:
      'Failed to access utility interval data as email approval was unsuccessful',
    PLUGINVALIDCREDENTIALSMSG: 'Connection failure due to invalid credentials'
  },
  virtualMeters: {
    SELECTED: 'Electricity Meters - Selected ({count})',
    SEARCHMETERS: 'Search Meter name',
    METERGROUPDETAILS: 'METER GROUP DETAILS',
    METERGROUPNAME: 'Meter Group Name',
    DESCRIPTION: 'Description',
    DESCRIPTIONPLACEHOLDER: 'Max 240 characters',
    VALIDATIONREQUIRED:
      'Atleast two meters must be selected and both inputs must be filled',
    SAVE: 'SAVE',
    CANCEL: 'CANCEL'
  },
  DetailedView: {
    TOTALEMISSIONS: 'Total Emissions',
    TOTALEMISSION: 'Total Emission',
    SCOPEONETITLE: 'Carbon Emissions by Scope 1',
    SCOPETWOTITLE: 'Carbon Emissions by Scope 2',
    SCOPE1: 'Scope 1',
    SCOPE2: 'Scope 2',
    SCOPEONEDATANOTCONSIDER: 'Scope 1 data need updates',
    CARBONTITLE: 'Carbon Emissions Overview',
    PORTFOLIOCARBONTITLE: 'Portfolio Carbon Emissions (CO2e)',
    TOTALEMISSIONSTOOLTIP:
      'Emission calculated for the selected duration from actuals with respect to previous year data.',
    CARBONTOOLTIPSUTILITYDETAIL:
      'Emission calculated for the selected duration from actuals with respect to previous year data. Actual carbon emission calculations are based on utility bill provided.',
    CARBONTOOLTIPLIVEDETAIL:
      'Emission calculated for the selected duration from actuals with respect to previous year data from the onsite meter. Real-time C02 calculations are based on the main meter.',
    CARBONTOOLTIPINTRVALDETAIL:
      'Emission calculated for the selected duration from actuals with respect to previous year data. Actual carbon emission calculations are based on utility interval data.',
    SCOPEONETOOLTIP:
      'Direct emission calculated for the selected duration from actuals with respect to previous year data.',
    SCOPETWOTOOLTIP:
      'Indirect emission calculated for the selected duration from actuals with respect to previous year data.',
    SCOPEONETOOLTIPUTILITY:
      'Direct emission calculated for the selected duration from actuals with respect to previous year data. Actual carbon emission calculations are based on utility bill provided.',
    SCOPEONETOOLTIPINTERVAL:
      'Direct emission calculated for the selected duration from actuals with respect to previous year data. Actual carbon emission calculations are based on utility interval data.',
    SCOPEONETOOLTIPLIVE:
      'Direct emission calculated for the selected duration from actuals with respect to previous year data from the onsite meter. Real-time C02 calculations are based on the main meter.',
    SCOPETWOTOOLTIPdUTILITY:
      'Indirect emission calculated for the selected duration from actuals with respect to previous year data. Actual carbon emission calculations are based on utility bill provided.',
    SCOPETWOTOOLTIPINTERVAL:
      'Indirect emission calculated for the selected duration from actuals with respect to previous year data. Actual carbon emission calculations are based on utility interval data.',
    SCOPETWOTOOLTIPLIVE:
      'Indirect emission calculated for the selected duration from actuals with respect to previous year data from the onsite meter. Real-time C02 calculations are based on the main meter.',
    CARBONDETAILKEY: 'carbondetail',
    SCOPEONEKEY: 'detailSummaryWithoutCurrency',
    UTILITYDETAILKEY: 'utilitydetail',
    METER: 'METER',
    METERNAME: 'METER NAME',
    FUELTYPE: 'FUEL TYPE',
    SITES: 'SITES',
    SOURCE: 'SOURCE',
    CURRENTAVOIDANCE: 'CURRENT AVOIDANCE',
    PREVIOUSAVOIDANCE: 'PREVIOUS AVOIDANCE',
    UTILITYTYPE: 'UTILITY TYPE',
    ACTUALEMISSION: 'ACTUAL EMISSIONS',
    ACTUALEMIS: 'ACTUAL EMIS.',
    PREVIOUSEMISSION: 'PREVIOUS EMISSIONS',
    PREVIOUSPERIOD: 'PREVIOUS EMIS.',
    PREVIOUSEMISSIONS: 'Previous Emissions',
    // PORTFOLIOACTUALEMISSION: 'ACTUAL CONS.',
    PORTFOLIOPREVIOUSConsumption: 'PREVIOUS PERIOD',
    PORTFOLIOACTUALEMISSION: 'ACTUAL EMISSIONS',
    PORTFOLIOPREVIOUSEMISSION: 'PREV. EMISSIONS',
    PORTFOLIOPREVIOUSCOST: 'PREV. COST',
    CHANGE: 'CHANGE',
    ACTUALCONS: 'ACTUAL CONS.',
    BASELINECONSP: 'BASELINE CONS.',
    PREVPERIOD: 'PREV. PERIOD',
    CHANGEPERCENT: '%CHANGE',
    EUICURRENT: 'EUI CURRENT',
    EUIPRVPERIOD: 'EUI PRV. PERIOD',
    PORTFOLIOACTUALCOST: 'ACTUAL COST',
    SAVINGS: 'SAVINGS',
    FuelType: 'Fuel Type',
    Emissions: 'EMISSIONS',
    CARBONAVOIDANCE: 'Carbon Avoidance',
    carbonEmissionsAvoidance: 'Carbon Emissions Avoidance',
    TOTALAVOIDANCETOOLTIP:
      'Carbon Avoidance calculated for the selected duration from actuals with respect to previous year data.',
    Meters: 'Meters',
    ActivePower: 'Active Power',
    ActivePowerContent:
      'Instantaneous power measured for a particular instant of time.',
    AVGpower: 'Average power',
    PeakPower: 'Peak Power',
    PeakPowerContent: 'Maximum power demand for the date range selection.',
    LoadType: 'Load type',
    LoadTypeContent: 'Type of load the meter is associated with.',
    FifteenMinuteElectricConsumption: '15 Min. Cons.',
    FifteenMinuteElectricConsumptionPrediction: '15 Min. Pred.',
    ElectricityConsumption: 'Total Energy Consumption',
    EnergyConsSelectedPeriod: 'Energy Consumption Selected Period',
    EnergyConsToday: 'Energy Consumption Today',
    EnergyConsTodayContent: 'Total energy consumption for today.',
    EnergyConsMonth: 'Energy Consumption Month',
    EnergyConsMonthContent: 'Total energy consumption for the current month.',
    TotalEnergyConsumption: 'Total Energy Consumption',
    TotalEnergyConsumptionContent: 'Meters totalized consumption',
    EnergyConsSelectedPeriodContent: 'Energy Consumption Selected Period',
    DataQuality: 'Data quality',
    BaselineQuality: 'Baseline quality',
    PowerDemand: 'Power Demand',
    APPLYBASELINEFROMDATEINVALID:
      'Please select date not older than last 15 days',
    INVALIDEXCLUSIONRANGESELECTION:
      'Please select exclusion date within the training date range selected'
  },
  NILM: {
    NILMModalHeader: 'Register for NILM',
    NILMMeterDetails: 'Add NILM Details',
    SmartXMeter: 'Preview',
    NILMDetailsTabHeader:
      'Please enter your Non-Instrusive Load Monitoring (NILM) meter details to add them in HBSM',
    NILMDetailsTabSubHeader: 'NILM Meter Details',
    NILMMeterId: 'Data ID/UUID',
    NILMDISAGGREGATEDMETERID: 'Disaggregated Data ID/UUID (Optional)',
    NILMMeterName: 'Meter Name',
    NILMAddMeter: 'Add Meter',
    NIMAssignMainMeter: 'Assign as Main Meter',
    NILMNextButton: 'Next',
    NILMSubmitButtom: 'Submit',
    NILMCancelButton: 'Cancel',
    NILMcardheader: 'Non-Intrusive Load Monitoring (NILM)',
    NILMcardsubheader:
      'Determine the breakdown of your site’s energy consumption by the types of equipment',
    NILMRedirect: 'You will be redirected in 5 sec',
    NILMAccountVerification: 'Account Verification in Process',
    NILMAccountVerificationSuccess: 'Account Verification is Success',
    INVALIDNILMMETERID: 'invalid meter installation id',
    METERNAMEINVALID: 'meter name already exist for the site',
    NILMMainmeter: '(Assigned as Main Meter)',
    NILMsmartXmeterheader:
      'Below are your NILM Meters. Please verify to continue and click on submit',
    NILMDUPLICATEMETERNAME: 'duplicate meter name',
    NILMDUPLICATEMETERID: 'duplicate meter id',
    IDDUPLICATETOGETHER: 'inavlid and duplicate UUID',
    NAMEDUPLICATETOGETHER: 'meter name already exist and duplicate'
  },
  energyStar: {
    EnergySubcriptionPeriod: 'For the 12 month period ending -',
    NoRecordsFound: 'No records found',
    LearnText: 'Learn more',
    outOfHundred: '/100',
    CurrentScore: 'Current score',
    EnergyTooltipHeader: 'Energy Usage',
    EnergyTooltipContent:
      'Energy star score is a measurement of how well your property is performing relative to similar properties, when normalised for climate and operational characteristics.',
    EnergyStarTitle: 'Energy Star-score',
    loading: 'Loading',
    ViewText: 'View Score Details',
    NA: 'N/A',
    SomethingWentWrong: 'Note',
    notifyServerError:
      'There is some server side error. Please contact system administrator.',
    ReasonForNoScoreLabel:
      'The Energy Star Score could not load due to a few technical errors.',
    ViewReasonForNoScore: 'View Reason for No Score Details',
    EnergyStarNoScoreNote:
      'The Energy Star score displayed is from {prevMonth}, as the previous month score is unavailable.',
    EnergyStarNoScoreNoContentMessage:
      'No reason for no score information found!'
  },
  equipmentSpaceMapping: {
    // File Validations
    FILE_NOT_ACCEPTED:
      '"{fileName}" is an invalid file format. Accepted only .{extension} file format',
    INVALIDFILE_EXTENSION:
      'Invalid file extension, Please use valid .{extension} file.',
    INVALIDFILE_MIME:
      'Invalid file mime type, Please use file with valid mime-types: {mimeTypes}.',
    INVALIDFILE_MAXALLOWEDSIZE: 'File size should be less than {size}',
    INVALIDFILE_MINALLOWEDSIZE: 'File size should be more than {size}',
    INVALIDFILE_UNKNOWNERROR:
      'Some error occurred in accessing file information. Cannot validate',

    // Schema Validation
    INVALID_SCHEMA_REQUIRED_HEADERS:
      'Uploaded excel file has invalid columns. Please use appropriate template and re-upload the excel file.',
    INVALID_SCHEMA_LIST_REQ_HEADERS: 'Required Headers: {requiredSubHeaders}',

    // Data Validations
    EMPTY: '',
    NO_DATA: 'File does not have any data',
    INVALID_DATA_CONTENT: 'First data row should contain a spatial element',
    SOME_ERROR_EXCEL_READ:
      'Some Error Occurred in Reading Excel File. Error: {errorString}',
    SOME_ERROR_GENERAL:
      'Some Error Occurred. Please re-select and upload a valid file. Error Details -> {errorString}',
    PROPERTY_INVALID_DATA_TYPE: 'Invalid Data Type. Allowed: {type}',
    NAME_INVALID_SPECIAL_CHAR: 'Name has invalid special character',
    NAME_INVALID_MAX_LEN: 'Max {len} characters allowed',
    SPATIAL_ELE_NEW: 'New Area will be created',
    NO_ASSOC_REMOVE:
      'No VAV / Occupancy Sensor Mapped. Please remove this entry',
    PROPERTIES_INVALID: 'Some Properties are invalid',
    SPATIAL_ELEMENT_NAME_MISMATCH:
      'For provided Spatial Element Id ({id}), Name from Sheet and registered in site ({dbSpEleName}) do not match',
    ELEMENT_NAME_MISMATCH:
      'For provided Element Id ({id}), Name from sheet and from registered in site ({dbEleName}) do not match',
    DUPLICATE_ENTRIES: 'Multiple entries with same name',
    MULTIPLE_EQUIPMENTS_SAME_NAME:
      'The site has multiple equipments registered with same name. Please rename this equipment to a unique name to associate',
    ELEMENT_ID_DNE: '{type} with provided Id ({id}) does not exist',
    SPATIAL_ELEMENT_ID_DNE: 'Area with provided Id ({id}) does not exist',
    ELEMENT_TYPE_NAME_DNE: '{type} with this name does not exist',
    PROPERTY_DNE: 'Property with name {name} does not exist. Please check'
  },
  ZLOOnboardingConfig: {
    UPLOAD_CARD_TITLE_ZLO: 'ZLO Equipment Space Mapping & Configuration',
    UPLOAD_CARD_DESC_ZLO:
      'Upload Equipment to Space Mapping Data for ZLO Onboarding and Configuration',
    UPLOAD_MODAL_TITLE: 'Upload ZLO Onboarding Data',
    VALIDATE_DATA: 'Upload', // Validate makes sense but HUE had upload
    BACK_TO_UPLOAD: 'Back',
    UPLOAD_TAB_TOP_NOTE:
      'Please download the template and fill the Spatial Element details along with Equipment related details in the template before proceeding to upload',
    UPLOAD_TAB_DOWNLOAD_TEMPLATE_BTN: 'Download XLSX Template',
    UPLOAD_TAB_SECOND_NOTE: '(Only one upload possible at a time)',
    UPLOAD_TAB_PLACEHOLDER: 'Drag and Drop a file here',

    // Validation Step
    VALIDATING_FILE_DATA: 'Validating File Data',
    READING_FILE: 'Reading File',
    VALIDATING_FILE_SCHEMA: 'Validating File Schema',
    RETRIEVING_SITE_DATA: 'Retrieving Site Data for Validation',
    VALIDATING_DATA_ENTRIES: 'Validating Data',
    // Post Validation Step
    ALL_ENTRIES_VALID: 'All Entries are Valid',
    SUBMIT_TO_PROCEED_SUBTEXT:
      'Please click on submit to proceed further and register in HBSM',
    VIEW_ALL_ENTRIES: 'View All Entries',
    FIX_VAL_ERRORS_MSG:
      'Below are the erroneous entries of ZLO Onboarding and Configuration Data. Please go back to upload tab and re-upload excel without the erroneous entries to register in HBSM',
    VAL_OK_SUBMIT_MSG:
      'Please click on submit to proceed further and register in HBSM',
    ERROR_BOX_TEXT:
      '{numErrors} errors identified. Please rectify them and re-upload the file to submit and register in HBSM',
    VALIDATION_ERROR_TITLE: 'Error in Validation',
    TOTAL: 'Total',
    CURRENTLY_SHOWING: 'Displaying {num} of {total} Total',
    SHOW_ALL_ENTRIES: 'Show All Entries',
    SL_NO: 'Sl. No',
    SPATIAL_ELE_NAME: 'Spatial Element Name',
    ELE_TYPE: 'Element Type',
    ELE_NAME: 'Name',
    ZLO_STATE: 'ZLO State',
    ZO_SETBACK: 'Zone Optimization Setback (F)',
    VAV: 'Variable Air Volume',
    OCCUPANCY_SENSOR: 'Occupancy Sensor',
    VAV_ETYPE: 'VAV',
    OCCUPANCY_SENSOR_ETYPE: 'OccupancySensor',
    SEARCH_PLACEHOLDER: 'Search',
    SEARCH_MIN_LEN: 'Min {len} Characters',
    NO_DATA: 'No Data matches your search',
    VALIDATING_TITLE: 'Validating Uploaded File',
    SOME_ERROR_FETCHING_DATA:
      'Some error occurred in fetching site data. Error: {errorString}',
    SUBMITTING_TITLE: 'Please wait while we Map Equipment to Space',
    SUBMITTING_SUBTITLE: 'You will be redirected in few seconds',
    CREATING_NEW_SPATIAL_ELEMENTS: 'Creating New Spaces',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS: 'Mapping Equipments to Spaces',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS_ERROR_MESSAGE:
      'Some Error in Mapping element to spatial element. Please try again later',
    UPDATING_PROPERTIES: 'Updating Properties',
    SUBMISSION_SUCCESS_TITLE: 'The Equipment To Space Mapping was Successful',
    SUBMISSION_ERROR_TITLE: 'Error in Submitting Data',
    SUBMISSION_ERROR_MESSAGE:
      'Some Error in submitting data. Please try again later',
    BULK_CREATION_ERROR_MESSAGE:
      'Error occured while creating spatial elements. Please try again later.',
    UPDATE_PROPERTY_ERROR_MESSAGE:
      'Error occured while updating properties. Please try again later.',
    SUBMISSION_SUCCESS_SUBTITLE:
      'The VAV and Occupancy Sensors mapped to the Spaces would reflect under the equipments tab in Site Home Page',
    GOTO_SITE_HOME_PAGE: 'Go To Site Home Page',
    'Items per Page': 'Rows per Page'
  },
  utilityBreakDown: {
    SUMMARYTABLESUBHEADER:
      'Below information always shown as per billing information cycle'
  },
  UtilityBuilder: {
    NEWBILL: 'New Bill',
    ENTERDATAMANUALLY: 'Enter Data Manually',
    BILLNAME: 'Bill Name',
    BILLINGDATE: 'Billing Date',
    TOTAL_BILL_AMOUNT: 'Total Bill Amount',
    BILLING_PERIOD_CONSUMPTION: 'Billing Period Consumption',
    BILLING_DEMAND: 'Billing Demand',
    ENTER_PLACEHOLDER: 'Enter',
    SELECT_PLACEHOLDER: 'Select',
    CATEGORIES: 'Categories',
    ACCOUNTNUMBER: 'Account Number',
    UTILITYTYPE: 'Utility Type',
    BILLINGCYCLE: 'Billing Cycle',
    UPLOADELECTRICITYBILL: 'Upload Electricity Bill',
    UPLOADGASBILL: 'Upload Gas Bill',
    ADDELECTRICITYBILL: 'Add Electricity Bill',
    ADDGASBILL: 'Add {utilityType} Bill',
    UPLOADUTILITYBILL: 'Upload Utility Bill',
    PDFUPLOADPROMPT: 'Please upload a PDF file of the utility bill',
    UploadElectricitybill: 'Upload Electricity Bill*',
    Utilitybill: 'Utility Bill',
    UPLOADBILL: 'Upload {utilityType} Bill',
    UPLOADELECTRICITYBILLNONMANDATORY: 'Upload Electricity Bill',
    FILENAMECONTAINSPACES: 'Filename contains Space(s).',
    FILENAMECONTAINSPECIALCHARACTER: 'Filename contains Special Character(s).',
    PDFEXTENSION: '.pdf',
    BILLCATEGORIES: 'Bill Categories',
    REFERSAMPLEBILL: 'refer the sample bill.',
    INPUTCATEGORIES:
      'Please input the different categories and corresponding costs from your {utilityType} bill. If help is required to locate them on the bill, '
  },
  baseline: {
    baselineconfiguration: 'Baseline Configuration',
    baselineConfigDesc:
      'Adjusted baselines establish the expected consumption of the utility for a site, based on a combination of historical consumption, recent trends and known impacts such as weather variables.',
    baseline: 'Baseline',
    total: 'Total',
    searchPlaceholder: 'Search For',
    create: 'Create Baseline',
    view: 'View Baseline',
    baselineQuality: 'Baseline Quality',
    baselinePeriod: 'Baseline Period',
    reportingPeriod: 'Reporting Period',
    estBaselinePeriod: 'Establish Baseline Period',
    baselinePeriodDescription:
      'Select the baseline period and reporting period for which you need to create baseline',
    independentVariables: 'Independent Variables',
    autoSelectBest: 'Auto select best variables',
    utilityDataType: 'Utility Data Type',
    calendarMonth: 'Calendar Month',
    billingPeriod: 'Billing Period',
    tStat: 'T-Stat'
  },
  utilityManagement: {
    ADD_ACCOUNT: 'ADD ACCOUNT',
    ADD_METERS: 'ADD METERS'
  }
};

export const nonDescriptorMessages: Record<string, string> = {
  'TOTAL BILL AMOUNT': 'Total Bill Amount',
  Consumption: 'Consumption',
  Demand: 'Demand',
  'Service Charges': 'Service Charges',
  'Transmission & Distribution': 'Transmission & Distribution',
  Others: 'Others',
  'Demand Charges': 'Demand Charges',
  'Total Cost': 'Total Cost',
  Total: 'Total'
};
